// extracted by mini-css-extract-plugin
export var boxItems = "_ax-1";
export var boxItemsLg = "_ax-2";
export var button = "_ax-7";
export var buttonHoverless = "_ax-9";
export var buttonLg = "_ax-8";
export var filterGroupBox = "_ax-0";
export var icon = "_ax-3";
export var iconSecondary = "_ax-6";
export var iconWrapper = "_ax-4";
export var iconWrapperLg = "_ax-5";
export var truncatedLabel = "_ax-a";